function togglePDPDesc() {
  //if key feature available
  if ($(".ht-pdp-key-feature").length > 0) {
    var aTag = $(".ht-pdp-key-feature").offset().top;
    $("html,body").animate({ scrollTop: aTag - 120 }, 1000);
  } 
  else {
    //if key feature not available
    let divElement = document.getElementById("pdp-description");
    divElement.classList.toggle("show-full-desc");
    if (document.getElementsByClassName("show-full-desc").length) {
      document.getElementById("toggle-description").innerHTML = "Read Less";
    } else {
      document.getElementById("toggle-description").innerHTML = "Read More";
    }
  }
}
$(document).on("click", ".vis_info_box", function () {
  var aTag = $("#vis-section").offset().top;
  $("html,body").animate({ scrollTop: aTag - 120 }, 1000);
});

$(document).ready(function(){
  //********************* Personalise code ********************************//
  /*if($('.pp-title').length > 0){
    var ppmessage = '';
    $(document).on('click', '[name="pp_msg"]', function(){
      $('.pp-contentbox').hide();
      $('.pp-contentbox #message').val('');      
      $('.pp-contentbox #birthyear').val('');
      var thisVal = $(this).val();
      
      if(thisVal == 'year'){
        $('.pp-yearbox').show();         
      }
      else{
        $('.pp-textbox').show();     
      }
    })
  }*/
  //********************* fixed add to cart on bottom ********************************//
  var eleTop = $('.product-form__submit').offset().top;
  var relatedPos = $('product-recommendations').offset().top;
  $(window).scroll(function(){
    var sticky = $('.product-form__submit'),
        scroll = $(window).scrollTop();
  
    if (scroll >= eleTop + 50 ) sticky.addClass('fixed');
    else sticky.removeClass('fixed');
    
    var fixedCtaPos = $('.product-form__submit').offset().top;
    //console.log("fixedCtaPos: ",fixedCtaPos)
    if (fixedCtaPos-100 >= relatedPos ) sticky.removeClass('fixed');
  });
})